import type React from 'react';
import ReactECharts from 'echarts-for-react';
import type {SpendAnalysis} from '../../types/categoryProfileTypes';
import {LOCALE} from '~/pages/category-profile/domain/locale';

type Props = {trend: SpendAnalysis['trend'], money: (v: number) => string};

const MONTH = new Intl.DateTimeFormat(LOCALE, {month: 'short', year: '2-digit'});
const LINE = '#2D6FF5';

/** Monthly spend (line with area) against the same month a year earlier (dashed); spikes (> 30% month on month) marked. */
export const SpendTrendChart: React.FC<Props> = ({trend, money}) => {
    const months = trend.map(p => MONTH.format(new Date(p.month)));
    const option = {
        grid: {left: 64, right: 16, top: 32, bottom: 28},
        tooltip: {trigger: 'axis', valueFormatter: (v: number) => money(v)},
        legend: {top: 0, right: 0, icon: 'roundRect', data: ['This year', 'A year earlier']},
        xAxis: {type: 'category', data: months, boundaryGap: false, axisTick: {show: false}},
        yAxis: {type: 'value', splitNumber: 3, axisLabel: {formatter: (v: number) => money(v)}},
        series: [
            {
                name: 'This year', type: 'line', data: trend.map(p => p.spend), smooth: false, symbol: 'circle', symbolSize: 7,
                lineStyle: {color: LINE, width: 2}, itemStyle: {color: '#fff', borderColor: LINE, borderWidth: 2},
                areaStyle: {color: 'rgba(45, 111, 245, 0.10)'},
                markPoint: {
                    symbol: 'pin', symbolSize: 34, itemStyle: {color: '#ED6C02'}, label: {fontSize: 9, formatter: 'Spike'},
                    data: trend.map((p, i) => (p.spike ? {coord: [i, p.spend]} : null)).filter(Boolean),
                },
            },
            {
                name: 'A year earlier', type: 'line', data: trend.map(p => p.priorSpend), symbol: 'none',
                lineStyle: {color: '#9AA0A8', type: 'dashed', width: 1.5}, itemStyle: {color: '#9AA0A8'},
            },
        ],
    };
    return <ReactECharts option={option} style={{height: 260}} notMerge/>;
};
